module.exports = __webpack_public_path__ + "img/testpaper_next_right.a14163b2.svg";